import { AppBar, Toolbar, Box, Menu, MenuItem, Avatar } from "@mui/material";
import { useState } from "react";

function AppBarHeader({user, handleLogOut}) {

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="fixed" sx={{ backgroundColor: "#ffffff", color: "#000", zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        <Box sx={{ flexGrow: 1 }}>
          <img
            src={`/logo/logisvalley-logo.png`} // public 폴더에 로고 파일 넣어줘 (예: public/logo.png)
            alt="회사 로고"
            style={{ height: 32 }} // 적절한 사이즈 조절
          />
        </Box>

        {/* 사용자 아이콘 */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer"
          }}
          onClick={handleMenuOpen}
        >
          <Avatar src={user.photoURL} sx={{ width: 24, height: 24, mr: 1 }} />
        </Box>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MenuItem onClick={() => { handleLogOut(); /* 로그아웃 처리 */ }}>
            로그아웃
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}

export default AppBarHeader;